(function() {
  var SelectBox,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  SelectBox = exports;

  SelectBox.filter = function(ids, data, selector, name_col, val_col, comp_col) {
    var filter, result;
    if (name_col == null) {
      name_col = 'name';
    }
    if (val_col == null) {
      val_col = 'id';
    }
    if (comp_col == null) {
      comp_col = 'id';
    }
    if (!(selector instanceof jQuery)) {
      selector = $(selector);
    }
    if (typeof data !== 'function') {
      data = TAFFY(data);
    }
    filter = {};
    filter[comp_col] = ids;
    result = data(filter).select(val_col, name_col);
    return SelectBox.render(result, selector);
  };

  SelectBox.prepareObject = function(data, name_col, val_col) {
    var i, k, len, output, v;
    if (name_col == null) {
      name_col = 'name';
    }
    if (val_col == null) {
      val_col = 'id';
    }
    output = [];
    for (k = i = 0, len = data.length; i < len; k = ++i) {
      v = data[k];
      output.push([v[val_col], v[name_col]]);
    }
    return output;
  };

  SelectBox.render = function(data, selector, first, trigger_change_event) {
    var i, ids, k, len, old_val, output, r, ref, v;
    if (first == null) {
      first = [
        {
          id: '',
          name: 'Select...'
        }
      ];
    }
    if (trigger_change_event == null) {
      trigger_change_event = true;
    }
    if (!(selector instanceof jQuery)) {
      selector = $(selector);
    }
    old_val = selector.val();
    selector.html('');
    output = first;
    ids = [];
    if (data instanceof Array) {
      for (i = 0, len = data.length; i < len; i++) {
        v = data[i];
        output.push({
          id: v[0],
          name: v[1]
        });
        ids.push(v[0]);
      }
    } else {
      for (k in data) {
        v = data[k];
        output.push({
          id: k,
          name: v
        });
        ids.push(k);
      }
    }
    r = $('#gbl_option_tmpl').render(output);
    selector.html(r);
    if (ref = parseInt(old_val), indexOf.call(ids, ref) >= 0) {
      return selector.val(old_val);
    } else if (old_val !== '') {
      selector.val('');
      if (trigger_change_event) {
        return selector.trigger('change');
      }
    }
  };

}).call(this);
